import api from '@/api'
import { formatDate } from '@/utils'
import searchEngines from '@/assets/maps/searchEngines'

const globalConfig = {
  state: {
    chartData: {
      series: [],
      tooltip: {
        formatter (params) {
          const data = params[0]
          let items = ''

          data.value.forEach((item, index) => {
            if (index > 1 && item.value) {
              items += `<div><span style="display:inline-block;margin-right:5px;border-radius:8px;width:8px;height:8px;background-color:${data.color};"></span>${item.label}：${item.value}</div>`
            }
          })

          return `
            <div style="padding: 0 10px;color: #666;">
              <div>${data.name}</div>
              <div style="font-size: 12px;">
                <div><span style="display:inline-block;margin-right:5px;border-radius:8px;width:8px;height:8px;background-color:${data.color};"></span>${data.seriesName}：${data.value[1]}</div>
                ${items}
              </div>
            </div>
          `
        }
      }
    },
    detail: {
      total: 0,
      list: []
    },
    allRecommendKeywords: [],
    keywordPackages: {
      totalKeywordCount: 0,
      list: []
    }
  },

  mutations: {
    SET_KEYWORDS_DETAIL (state, { total, keywords }) {
      state.detail.total = total
      state.detail.list = keywords
    },

    SET_ALL_RECOMMEND_KEYWORDS (state, { keywordPackageList }) {
      state.allRecommendKeywords = keywordPackageList
    },

    SET_KEYWORDS_CHART_DATA (state, { chartData }) {
      state.chartData.series = chartData.series
    },

    SET_KEYWORD_PACKAGE (state, { totalKeywordCount, keywordPackageList }) {
      state.keywordPackages.totalKeywordCount = totalKeywordCount
      state.keywordPackages.list = keywordPackageList
    }
  },

  actions: {
    getAllRecommendKeywords ({ commit }, data) {
      return api.keyword.getKeywordPackages({
        params: data.params
      }).then(response => {
        commit('SET_ALL_RECOMMEND_KEYWORDS', response.data)
        return response
      })
    },

    getKeywordPackages ({ commit }, data) {
      return api.keyword.getKeywordPackages({
        params: data.params
      }).then(response => {
        commit('SET_KEYWORD_PACKAGE', response.data)
        return response
      })
    },

    getKeywords ({ commit }, data) {
      return api.search.queryKeywords(data).then(response => {
        const total = response.data.total || 0
        const keywords = response.data.results || []

        commit('SET_KEYWORDS_DETAIL', {
          total,
          keywords: keywords.map(item => ({
            keyword: item.keyword,
            category: item.package_name,
            type: item.keyword_type,
            isPublish: item.is_pub,
            searchEngine: item.search_engine,
            rank: item.rank,
            url: searchEngines.getQueryUrl(item.search_engine, item.keyword)
          }))
        })

        return response
      })
    },

    getKeywordsChartData ({ commit }, data) {
      return api.stats.getUserKeywordRankTrend(data).then(response => {
        const data = response.data.results
        const line = {
          name: '排名总量',
          type: 'line',
          data: [],
          itemStyle: {
            normal: {
              color: '#2a85ff',
              lineStyle: {
                color: '#2a85ff',
                width: 2
              }
            }
          }
        }

        data.forEach((item, index) => {
          const date = formatDate(item.date, 'YYYY-MM-DD', 's')
          const rankCount = item.ranks.rank_count

          line.data.push([
            date,
            rankCount,
            { label: searchEngines.getLabelById(1), value: item.ranks[1] },
            { label: searchEngines.getLabelById(2), value: item.ranks[2] },
            { label: searchEngines.getLabelById(3), value: item.ranks[3] },
            { label: searchEngines.getLabelById(4), value: item.ranks[4] },
            { label: searchEngines.getLabelById(5), value: item.ranks[5] },
            { label: searchEngines.getLabelById(6), value: item.ranks[6] }
          ])
        })

        commit('SET_KEYWORDS_CHART_DATA', {
          chartData: {
            series: [ line ]
          }
        })

        return response
      })
    }

  }
}

export default globalConfig
